export default "__VITE_ASSET__fgf2l6Yj__"